/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  pageTitle: 'Installation setup',

  tabs: {
    license: 'License data',
    dummyData: 'Insert demo data',
    topics: 'Add Rawam topics',
    usersPurge: 'Delete Selected',
  },

  license: {
    cardTitle: 'License data',
    fileLabel: 'License File',
    fileHint: 'The licence file issued by CoEIA, as a .json document',
    apply: 'Apply',
  },

  dummyData: {
    cardTitle: 'Create users and groups, and simulate course and exam activity',
    usersCountLabel: 'User Number',
    action: 'Insert dummy data',
  },

  topics: {
    cardTitle: 'Publish the topics found in the Rawam.Content folder…',
    action: 'Publish',
  },

  usersPurge: {
    fileLabel: 'Users List',
    action: 'Delete Selected',
  },

  waitScreen: 'Please wait...',

  close: 'Close',

  footer: 'Center of Excellence in Information Assurance',

  accessGate: {
    prompt: 'Please enter the access code:',
    confirm: 'Agree',
    cancel: 'Cancel',
    denied: 'Access was denied, or the server returned an error.',
  },

  messages: {
    success: 'Operation Completed Successfully',

    invalidFiles: 'The files you uploaded are not valid!',

    onlyNewLicense: 'Only the (new) license operation type is allowed in the install section!',

    cannotOpenFile: 'Error: the supplied file could not be opened. Please check the file name and/or its location',

    emptyFile: 'Error: the supplied file is empty!',

    purgeFinished: 'The operation finished successfully…',
  },

  logoAlt: 'Rawam',
}
